// product grid/list
function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach((link) => {
    link.addEventListener("click", function (event) {
      Array.from(document.querySelectorAll(".wblistgridbtn")).forEach((e) =>
        e.classList.remove("active")
      );
      this.classList.add("active");
      if (this.classList.contains("listv")) {
        document.getElementById("product-grid").classList.add("product-list");
        document
          .getElementById("product-grid")
          .classList.remove("product-grid");
        document
          .getElementById("product-grid")
          .classList.remove("product-gallery");
        // Remove 'active' class from gridv on mobile
        if (window.innerWidth < 992) {
          document.querySelector(".gridv").classList.remove("active_mobile");
        }
      } else if (this.classList.contains("gridv")) {
        document.getElementById("product-grid").classList.add("product-grid");
        document
          .getElementById("product-grid")
          .classList.remove("product-list");
        document
          .getElementById("product-grid")
          .classList.remove("product-gallery");
      } else if (this.classList.contains("galleryv")) {
        document
          .getElementById("product-grid")
          .classList.add("product-gallery");
        document
          .getElementById("product-grid")
          .classList.remove("product-list");
        document
          .getElementById("product-grid")
          .classList.remove("product-grid");
      }
    });
  });
}
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener("load", videoScroll);
window.addEventListener("scroll", videoScroll);
function videoScroll() {
  if (document.querySelectorAll("video[autoplay]").length > 0) {
    var windowHeight = window.innerHeight,
      videoEl = document.querySelectorAll("video[autoplay]");
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
        videoHeight = thisVideoEl.clientHeight,
        videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if (
        videoClientRect <= windowHeight - videoHeight * 0.5 &&
        videoClientRect >= 0 - videoHeight * 0.5
      ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}
